var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkpapersLogoBackdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 346,
    viewBox: "0 0 296 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2192_2234)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M0 346V216.199C0 190.973 12.2494 167.295 32.8398 152.693L100.783 104.574C104.906 101.644 107.361 96.9277 107.361 91.8538V0H214.698V18.9139C214.698 32.468 208.12 45.1884 197.039 53.0255L112.151 113.15C109.124 115.294 107.337 118.748 107.337 122.464V346.024H0V346ZM228.639 346V256.076C228.639 251.026 231.094 246.285 235.217 243.355L303.16 195.237C323.774 180.658 336 156.98 336 131.73V0H228.663V225.537C228.663 229.229 226.876 232.707 223.849 234.851L138.961 294.975C127.88 302.813 121.302 315.533 121.302 329.087V346.024H228.639V346Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2192_2234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 346,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkpapersLogoBackdrop);
export default __webpack_public_path__ + "static/media/workpapers-logo-backdrop.4f9efd9c46d79af96b17f74915498e3d.svg";
export { ForwardRef as ReactComponent };